
import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import axios from "axios";
import Lottie from "lottie-react";
import {
  Box,
  Typography,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ToggleOn as ToggleOnIcon,
  ToggleOff as ToggleOffIcon,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";

import { API_BASE_URL } from "../../../../utils/index";
import { useAuthHeaders } from "../../../../components/Token";
import Preloader from "../../../../Preloader/Preloader-Animation.json";
import { DELETECategory, GetVendorCategory, UpdatestatusVendorCatergoery } from "../../../../services/api/Category";
import userContext from "../../../../components/UseContext/UseContext";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";

function VendorCategorys() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const headers = useAuthHeaders();
  const subdomain = localStorage.getItem("vendorsubdomain");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const { permissionvalues } = useContext(userContext);
  const
    permissions = permissionvalues?.permissions?.master.category
  useEffect(() => {
    const fetchHandler = async () => {
      try {
        setLoading(true);
        const response = await GetVendorCategory(subdomain);
        if (response?.success) {
          setData(response.categories || []);
        }
      } catch (error) {
        console.error("Error loading categories", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHandler();
  }, []);

  const handleDelete = async () => {

    try {

      const response = await DELETECategory(subdomain, selectedId)
      if (response.success) {
        setData((prev) => prev.filter((item) => item._id !== selectedId));
        setSnackbar({ open: true, message: "Category deleted successfully!", severity: "success" });
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.error || "Error deleting category",
          severity: "error",
        });
      }
    } catch (error) {

    }
    finally {
      setOpenDialog(false);
      setSelectedId(null);
    }

  };

  const toggleCategoryStatus = async (id, currentStatus) => {
    const payload = { isActive: !currentStatus }
    const response = await UpdatestatusVendorCatergoery(subdomain, payload, id)
    if (response.success) {
      setData((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, isActive: !currentStatus } : item
        )
      );
      setSnackbar({ open: true, message: "Status updated!", severity: "success" });
    } else {
      setSnackbar({
        open: true,
        message: response?.data?.error || "Error updating status",
        severity: "error",
      });
    }

  };

  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const row = params.row;
        const validation = row?.vendor ? true : false
        return (
          <>
            {/* <Tooltip title="View">
              <IconButton component={RouterLink} to={`/categorysDetial/${row._id}`} size="small">
                <VisibilityIcon fontSize="small" />
              </IconButton>
            </Tooltip> */}
            {permissions.edit && validation &&
              <Tooltip title="Edit">
                <IconButton component={RouterLink} to={`/${subdomain}/master/category/edit/${row._id}`} size="small">
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            }
            {permissions.delete && validation &&
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    setSelectedId(row._id);
                    setOpenDialog(true);
                  }}
                  size="small"
                >
                  <DeleteIcon color="error" fontSize="small" />
                </IconButton>
              </Tooltip>
            }
            {
              permissions.edit && validation &&
              <Tooltip title={row.isActive ? "Deactivate" : "Activate"}>
                <IconButton
                  onClick={() => toggleCategoryStatus(row._id, row.isActive)}
                >
                  {row.isActive ? (
                    <BsToggleOn color="green" />
                  ) : (
                    <BsToggleOff color="gray" />
                  )}
                </IconButton>
              </Tooltip>
            }
          </>
        );
      },
    },
  ];

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Categories</Typography>
        {permissions?.create &&
          <Button component={RouterLink} to={`/${subdomain}/master/category/create`} variant="contained">
            Add New
          </Button>
        }
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={300}>
          <Lottie animationData={Preloader} style={{ width: 200 }} />
        </Box>
      ) : (
        <Box sx={{ height: 370 }}>
          {permissions?.read &&
            <DataGrid
              rows={data}
              columns={columns}
              getRowId={(row) => row._id}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
              pagination
              disableRowSelectionOnClick
            />
          }
        </Box>
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this category? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default VendorCategorys;
